import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.test';

import { DueDateJson } from './microservices/json/dueDate.json';
import { MicroResponse } from './microservices/response/micro.response';
import { SignatureResponse } from './microservices/response/signature.response';
import { SignatureSimpleResponse } from './microservices/response/signatureSimple.response';

@Injectable()
export class SignatureService {
  private signatureService = `${environment.IDEMPIER_GATEWAY}/v1/signature`;
  private http = inject(HttpClient);

  save(params: FormData): Observable<MicroResponse<SignatureSimpleResponse>> {
    return this.http.post<MicroResponse<SignatureSimpleResponse>>(
      this.signatureService,
      params,
    );
  }

  get(): Observable<MicroResponse<SignatureResponse>> {
    return this.http.get<MicroResponse<SignatureResponse>>(
      this.signatureService,
    );
  }

  getSignatureSimple(): Observable<MicroResponse<SignatureSimpleResponse>> {
    return this.http.get<MicroResponse<SignatureSimpleResponse>>(
      `${this.signatureService}/projection?fields=id,dueDate`,
    );
  }

  check(params: FormData): Observable<MicroResponse<DueDateJson>> {
    return this.http.post<MicroResponse<DueDateJson>>(
      `${this.signatureService}/file`,
      params,
    );
  }
}
